import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { BidProps } from "@/interfaces/bid_types"
import { BidForm } from "./Form/BidForm"
import { getBid } from "./api/bids"
import { BidListMain } from "./Table/BidList"
import { EmployeeProps } from "@/interfaces/employee_type"
import { useAuth } from "@/App"

export function CreateBid() {
    const [formProps, setFormProps] = useState<BidProps>()
    const { category } = useParams<{ category: string }>()
    const { user } = useAuth()

    useEffect(() => {
        if (category) {
            setFormProps({
                category: category,
                bid_name: "",
                status: "Active",
                start_date: new Date().toISOString().split("T")[0],
                manager: user as unknown as EmployeeProps, // Bandaid to fix type error
                isDeadline: false,
                template: category === "Finishout" ? "Finishout" : "Bid Default",
            } as BidProps)
        }

    }, [category])

    return (
        <>
            {formProps && <BidForm method="POST" formProps={formProps}/>}
        </>
    )
}

export function UpdateBid() {
    const { id } = useParams<string>()

    const [currentBid, setCurrentBid] = useState<BidProps>()
    const navigate = useNavigate()

    useEffect(() => {
        if (!id) return

        const fetchBid = async () => {
            try {
                const data = await getBid(id)
                setCurrentBid({...data.data, bid_id: id})
            } catch (error) {
                console.error("error fetching bid:", error)
                navigate("/*")
            }
        }

        fetchBid()
    }, [id, navigate])

    return (
        <>
            {currentBid && <BidForm method="PUT" formProps={currentBid}/>}
        </>
    )
}

export function BidList() {
    return (
        <BidListMain />
    )
}